// extracted by css-extract-rspack-plugin
export default {"pageLayout":"src-app-pages-electronic-preparation-TodayPlan-TodayPlan-module__pageLayout-kdgvx8","headerTable":"src-app-pages-electronic-preparation-TodayPlan-TodayPlan-module__headerTable-GLxmFs"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageLayout\":\"src-app-pages-electronic-preparation-TodayPlan-TodayPlan-module__pageLayout-kdgvx8\",\"headerTable\":\"src-app-pages-electronic-preparation-TodayPlan-TodayPlan-module__headerTable-GLxmFs\"}";
        // 1789362522828
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  